export const calcularQtdDependentesPet = dependentes => {
    const qtdPets = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau'].trim() === 'PET'
    ).length;

    return qtdPets;
};

export const calcularQtdDependentesPetSemAdicional = dependentes => {
    const qtdPets = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau'].trim() === 'PET' &&
        dependente['CategoriaParentesco.Categoria'].trim() === 'ZELO'
    ).length;

    return qtdPets;
};

export const validatorPossui3Pets = (valoresForm,dependentes) =>{
    const arrayDeValidacoes = [
        possui3DependentesPet(dependentes),
        semValorAdicional(valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPermitirSomente3PetsSemValorAdicional = (valoresForm,dependentes) =>{
    const arrayDeValidacoes = [
        possui3PetsSemValorAdicional(dependentes),
        semValorAdicional(valoresForm),
        parentescoPetPreenchido(valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPermitirPetsComValorAdicional = (valoresForm,dependentes) =>{
    const arrayDeValidacoes = [
        !possui3PetsSemValorAdicional(dependentes),
        comValorAdicional(valoresForm),
        parentescoPetPreenchido(valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPermitirSomente3PetsSemValorAdicionalEdicao = (valoresForm,dependentes) =>{
    const arrayDeValidacoes = [
        possui3PetsSemValorAdicional(dependentes),
        !editandoDependenteSemAdicional(valoresForm, dependentes),
        semValorAdicional(valoresForm),
        parentescoPetPreenchido(valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPermitirPetsComValorAdicionalEdicao = (valoresForm,dependentes) =>{
    const arrayDeValidacoes = [
        possui3PetsSemValorAdicional(dependentes),
        editandoDependenteSemAdicional(valoresForm, dependentes),
        comValorAdicional(valoresForm),
        parentescoPetPreenchido(valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const possui3DependentesPet = dependentes => calcularQtdDependentesPet(dependentes) >= 3;
const semValorAdicional = valoresForm => valoresForm.Categoria !== 'ZPEA';
const comValorAdicional = valoresForm => valoresForm.Categoria === 'ZPEA';
const possui3PetsSemValorAdicional = dependentes => calcularQtdDependentesPetSemAdicional(dependentes) === 3;
const parentescoPetPreenchido = valoresForm => valoresForm.Parentesco === 'PET';
const editandoDependenteSemAdicional = (valoresForm,dependentes) => {
    const { Seq } = valoresForm;

    const dependentesSemAdicional = dependentes.filter(dependente =>  dependente['GrauParentesco.Grau'].trim() === 'PET' &&
    dependente['CategoriaParentesco.Categoria'].trim() === 'ZELO').map(dependente => dependente.Seq);

    return dependentesSemAdicional.includes(Seq);
};
